var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoAlign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1317_4927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9637 18.3207V25.7984H17.8425V18.3207H25.6001V14.5818H17.8425C15.7092 14.5818 13.9637 16.2643 13.9637 18.3207ZM17.8425 37.0151H13.9637V44.4928C13.9637 46.5492 15.7092 48.2317 17.8425 48.2317H25.6001V44.4928H17.8425V37.0151ZM44.994 44.4928H37.2365V48.2317H44.994C47.1274 48.2317 48.8728 46.5492 48.8728 44.4928V37.0151H44.994V44.4928ZM44.994 14.5818H37.2365V18.3207H44.994V25.7984H48.8728V18.3207C48.8728 16.2643 47.1274 14.5818 44.994 14.5818Z",
    fill: "#00AE9A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1317_4927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5637 21.3115H23.2728C21.9928 21.3115 20.9456 22.321 20.9456 23.5549V39.2581C20.9456 40.492 21.9928 41.5015 23.2728 41.5015H39.5637C40.8437 41.5015 41.891 40.492 41.891 39.2581V23.5549C41.891 22.321 40.8437 21.3115 39.5637 21.3115ZM39.5637 39.2581H23.2728V23.5549H39.5637V39.2581ZM33.699 31.7318L30.499 35.7025L28.2183 33.0553L25.0183 37.0148H37.8183L33.699 31.7318Z",
    fill: "#54C9BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1317_4927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5455,
    height: 44.8666,
    fill: "white",
    transform: "translate(8.14551 8.97339)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1317_4927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9273,
    height: 26.9199,
    fill: "white",
    transform: "translate(17.4546 17.9465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoAlign);
export default __webpack_public_path__ + "static/media/photoAlign.ccb83b2cda88bc9635240780eb8129a3.svg";
export { ForwardRef as ReactComponent };